export enum TelegramMethodEnum {
    IframeReady = 'iframe_ready',
    IframeWillReload = 'iframe_will_reload',
    WebAppAddToHomeScreen = 'web_app_add_to_home_screen',
    WebAppBiometryGetInfo = 'web_app_biometry_get_info',
    WebAppBiometryOpenSettings = 'web_app_biometry_open_settings',
    WebAppBiometryRequestAccess = 'web_app_biometry_request_access',
    WebAppBiometryRequestAuth = 'web_app_biometry_request_auth',
    WebAppBiometryUpdateToken = 'web_app_biometry_update_token',
    WebAppCheckHomeScreen = 'web_app_check_home_screen',
    WebAppCheckLocation = 'web_app_check_location',
    WebAppClose = 'web_app_close',
    WebAppCloseScanQrPopup = 'web_app_close_scan_qr_popup',
    WebAppDataSend = 'web_app_data_send',
    WebAppExitFullscreen = 'web_app_exit_fullscreen',
    WebAppExpand = 'web_app_expand',
    WebAppInvokeCustomMethod = 'web_app_invoke_custom_method',
    WebAppOpenInvoice = 'web_app_open_invoice',
    WebAppOpenLink = 'web_app_open_link',
    WebAppOpenLocationSettings = 'web_app_open_location_settings',
    WebAppOpenPopup = 'web_app_open_popup',
    WebAppOpenScanQrPopup = 'web_app_open_scan_qr_popup',
    WebAppOpenTgLink = 'web_app_open_tg_link',
    WebAppReadTextFromClipboard = 'web_app_read_text_from_clipboard',
    WebAppReady = 'web_app_ready',
    WebAppRequestContentSafeArea = 'web_app_request_content_safe_area',
    WebAppRequestEmojiStatusAccess = 'web_app_request_emoji_status_access',
    WebAppRequestFileDownload = 'web_app_request_file_download',
    WebAppRequestFullscreen = 'web_app_request_fullscreen',
    WebAppRequestLocation = 'web_app_request_location',
    WebAppRequestPhone = 'web_app_request_phone',
    WebAppRequestSafeArea = 'web_app_request_safe_area',
    WebAppRequestTheme = 'web_app_request_theme',
    WebAppRequestViewport = 'web_app_request_viewport',
    WebAppRequestWriteAccess = 'web_app_request_write_access',
    WebAppSendPreparedMessage = 'web_app_send_prepared_message',
    WebAppSetBackgroundColor = 'web_app_set_background_color',
    WebAppSetBottomBarColor = 'web_app_set_bottom_bar_color',
    WebAppSetEmojiStatus = 'web_app_set_emoji_status',
    WebAppSetHeaderColor = 'web_app_set_header_color',
    WebAppSetupBackButton = 'web_app_setup_back_button',
    WebAppSetupClosingBehavior = 'web_app_setup_closing_behavior',
    WebAppSetupMainButton = 'web_app_setup_main_button',
    WebAppSetupSettingsButton = 'web_app_setup_settings_button',
    WebAppSetupSwipeBehavior = 'web_app_setup_swipe_behavior',
    WebAppShareToStory = 'web_app_share_to_story',
    WebAppStartAccelerometer = 'web_app_start_accelerometer',
    WebAppStartDeviceOrientation = 'web_app_start_device_orientation',
    WebAppStartGyroscope = 'web_app_start_gyroscope',
    WebAppStopAccelerometer = 'web_app_stop_accelerometer',
    WebAppStopDeviceOrientation = 'web_app_stop_device_orientation',
    WebAppStopGyroscope = 'web_app_stop_gyroscope',
    WebAppSetupSecondaryButton = 'web_app_setup_secondary_button',
    WebAppSwitchInlineQuery = 'web_app_switch_inline_query',
    WebAppToggleOrientationLock = 'web_app_toggle_orientation_lock',
    WebAppTriggerHapticFeedback = 'web_app_trigger_haptic_feedback',
}
